module.exports = __webpack_public_path__ + "static/apple-touch-icon-120x120-2cd8d6eb5fa2ec9d20e2f1d00ac63823.png";